import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import VisibilityIcon from "@mui/icons-material/Visibility";
import DownloadIcon from "@mui/icons-material/Download";
import api from "../../../../api/api";
import Breadcrumbs from "../../../../components/Breadcrumbs";
import Pagination from "../../../../components/Pagination";
import Table from "../../../../components/table";
import usePagination from "../../../../utils/usePagination";
import "../../Common/form.css";
 
const ViewBookingDocument = () => {
  const { enq_id } = useParams();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [viewBookingDocuments, setViewBookingDocuments] = useState([]);
 
  // Fetch booking documents
  useEffect(() => {
    const fetchViewBookingDocument = async () => {
      setLoading(true);
      try {
        const response = await api.get(`/bookingDocuments/${enq_id}`);
        setViewBookingDocuments(response.data.documents || []);
      } catch (err) {
        setError("Failed to fetch booking documents");
        console.error(err);
      } finally {
        setLoading(false);
      }
    };
 
    if (enq_id) {
      fetchViewBookingDocument();
    }
  }, [enq_id]);
 
  // Sorting (same as your old logic)
  const filteredDocuments = Array.isArray(viewBookingDocuments)
    ? viewBookingDocuments
    : [];
 
  const sortedItems = [...filteredDocuments].sort((a, b) =>
    a.document_type.localeCompare(b.document_type)
  );
 
  // Pagination using shared hook
  const {
    currentPage,
    itemsPerPage,
    totalPages,
    totalItems,
    currentItems,
    goToPage,
    handleItemsPerPageChange,
  } = usePagination(sortedItems, 10);
 
  const handleDownload = async (docId, fileName) => {
    try {
      const response = await api.get(
        `/download-document/booking/${docId}`,
        { responseType: "blob" }
      );
      const blob = response.data;
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = fileName || "document";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Download failed:", error);
    }
  };
 
const columns = [
    {
      label: "Job Id",
      accessor: "job_number",
      render: (data) => data.job_number || data.enq_id,
    },
    {
      label: "Document Type",
      accessor: "document_type",
    },
    {
      label: "Document Name",
      accessor: "document_name",
    },
    {
      label: "Action",
      render: (item) => (
        <div className="d-flex gap-2 justify-content-center">
          <Link to={item.file_url} target="_blank" title="View">
            <VisibilityIcon style={{ fontSize: 20 }} />
          </Link>

          <span
            onClick={() => handleDownload(item.id, item.document_type)}
            title="Download"
            style={{ cursor: "pointer" }}
          >
            <DownloadIcon style={{ fontSize: 20 }} />
          </span>
        </div>
      ),
    },
  ];
 
  return (
    <>
      <Breadcrumbs />
 
      {error ? (
        <p className="text-danger text-center">{error}</p>
      ) : (
        <Table
          columns={columns}
          data={currentItems}
          loading={loading}
          emptyMessage="No booking documents found."
          itemsPerPage={itemsPerPage}
          pagination={
            <Pagination
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={goToPage}
              itemsPerPage={itemsPerPage}
              onItemsPerPageChange={handleItemsPerPageChange}
              totalItems={totalItems}
            />
          }
        />
      )}
    </>
  );
};
 
export default ViewBookingDocument;